import React from 'react';
import SelectInput from './SelectInput';
import Label from './Label';
import Tooltip from './Tooltip';

const bottomLine = (line) => {
  if (!line || line === '') {
    return null;
  }
  return (<span>{line}</span>);
};

const SelectDualComponent = props => {
  const { parameters } = props;
  const valueA = parameters[props.nameA];
  const valueB = parameters[props.nameB];
  return (
    <div className="form-group-dual">
      <Label label={props.label} required={props.required}> <Tooltip id={`tooltip-${props.nameA}`}
                                                                     title={props.tooltip} /> </Label>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <Label label={props.labelTopA} required={props.requiredA}> <Tooltip id={`tooltip-${props.nameA}`}
                                                                                title={props.tooltipA} /></Label>
            <SelectInput
              name={props.nameA}
              onChange={e => props.onChangeParameter(props.nameA, e.target.value)}
              selected={valueA}
              options={props.defaultOptionsA}
              groupName={props.groupName} />
            {bottomLine(props.labelBottomA)}
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <Label label={props.labelTopB} required={props.requiredB}> <Tooltip id={`tooltip-${props.nameB}`}
                                                                                title={props.tooltipB} /></Label>
            <SelectInput
              name={props.nameB}
              onChange={e => props.onChangeParameter(props.nameB, e.target.value)}
              selected={valueB}
              options={props.defaultOptionsB}
              groupName={props.groupName} />
            {bottomLine(props.labelBottomB)}
          </div>
        </div>
      </div>
    </div>
  )
};

SelectDualComponent.defaultProps = {
  label: '',
  labelTopA: null,
  labelTopB: null,
  tooltip: '',
  tooltipA: null,
  tooltipB: null,
  nameA: '',
  defaultOptionsA: [],
  labelBottomA: '',
  nameB: '',
  defaultOptionsB: [],
  labelBottomB: '',
  requiredA: false,
  requiredB: false,
};

export default SelectDualComponent;
